import { render, staticRenderFns } from "./detailReport.vue?vue&type=template&id=18e5511c&scoped=true"
import script from "./detailReport.vue?vue&type=script&lang=js"
export * from "./detailReport.vue?vue&type=script&lang=js"
import style0 from "./detailReport.vue?vue&type=style&index=0&id=18e5511c&prod&lang=css"
import style1 from "./detailReport.vue?vue&type=style&index=1&id=18e5511c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e5511c",
  null
  
)

export default component.exports